/** Normaliza status numérico/booleano/string retornado pela API de relatórios. */
export const normalizeRelatorioStatus = (status) => {
    if (status === null || status === undefined || status === '') return 'Status Desconhecido'

    const labels = {
        0: 'Processando',
        1: 'Em Processamento',
        2: 'Processado',
        3: 'Falha',
        false: 'Processando',
        true: 'Em Processamento',
    }

    if (labels[status] !== undefined) return labels[status]

    const text = String(status)
    if (['Processando', 'Em Processamento', 'Processado', 'Falha'].includes(text)) return text

    return 'Status Desconhecido'
}

export const isRelatorioEmAndamento = (status) => {
    const normalized = normalizeRelatorioStatus(status)
    return normalized === 'Processando' || normalized === 'Em Processamento'
}

export const relatorioStatusStyle = (status) => {
    const normalized = normalizeRelatorioStatus(status)
    switch (normalized) {
        case 'Processado':
            return 'bg-green-50 text-green-700 border-green-100'
        case 'Falha':
            return 'bg-red-50 text-red-700 border-red-100'
        case 'Em Processamento':
        case 'Processando':
            return 'bg-amber-50 text-amber-700 border-amber-100'
        default:
            return 'bg-gray-50 text-gray-600 border-gray-100'
    }
}
